export class CmsLinkType {
  static readonly ANCHOR = 'anchor'
  static readonly ANCHOR_BUTTON = 'anchor_button'
  static readonly CHATBOT_LINK = 'chatbot_link'
  static readonly CONTENT_LINK = 'content_link'
  static readonly CONTENT_LINK_BUTTON = 'content_link_button'
  static readonly COOKIE_SETTINGS = 'cookie_settings'
  static readonly DOCUMENT_LINK = 'document_link'
  static readonly DOCUMENT_LINK_BUTTON = 'document_link_button'
  static readonly EMAIL_LINK = 'email_link'
  static readonly EMAIL_LINK_BUTTON = 'email_link_button'
  static readonly PHONE_LINK = 'phone_link'
  static readonly PRINT = 'print'
  static readonly PRODUCT_LINK = 'product_link'
  static readonly PRODUCT_LINK_BUTTON = 'product_link_button'
  static readonly RELATED_PRODUCT_LINK = 'related_product_link'
  static readonly SPECIAL = 'special'
  static readonly URL = 'url'
  static readonly URL_BUTTON = 'url_button'
  static readonly VIDEO_LINK = 'video_link'
  static readonly VIDEO_LINK_BUTTON = 'video_link_button'
}
